import { Subtext, Text } from '../../../../Components/Screen/Text/Body'
import { Subheading } from '../../../../Components/Screen/Text/Heading'
import { child, get, ref } from 'firebase/database'
import { db } from '../../../../firebase'
import { useEffect, useState } from 'react'

export const StatsProfile = ({ art }) => {
  const [data, setData] = useState([])

  useEffect(() => {
    async function getUser() {
      const dbRef = ref(db)
      return get(child(dbRef, `/users/${art?.userId}`))
        .then((snapshot) => {
          if (snapshot.exists()) {
            const users = snapshot.val()
            setData(users)
          } else {
            console.log('No data available')
          }
        })
        .catch((error) => {
          console.error(error)
        })
    }
    getUser()
  }, [art?.userId])

  const collectionSize = Object?.values(data?.art || [])?.length
  const level = Math.floor(collectionSize / 10) + 1
  const progress = collectionSize % 10
  const nextLevel = level + 1
  const progressPercentage = (progress / 10) * 100

  return (
    <div className="flex w-full px-6 md:px-10 py-8 font-light">
      <div className="flex gap-8 flex-col sm:flex-row items-center sm:items-start w-full justify-between">
        <img
          src={
            data?.profilePicture ||
            'https://clinicforspecialchildren.org/wp-content/uploads/2016/08/avatar-placeholder.gif'
          }
          alt="profile"
          className="w-32 h-32 rounded-full object-cover object-center shrink-0"
          loading="eager"
        />
        <div className="flex flex-col gap-1 text-cinza min-w-0 flex-1">
          <Subheading>
            {data?.firstName} {data?.lastName}
          </Subheading>
          <Subtext>{data?.typeProfile}</Subtext>
          <Text>
            Fazendas: <span>{collectionSize || 0}</span>
          </Text>
          <Text>Nível na Farmie: {level}</Text>
          <Text>
            {progress} / 10 para o nível {nextLevel}
          </Text>
          <div className="w-full h-2 bg-cinzaescuro/50 rounded-full mt-1">
            <div
              className="h-full bg-cinzaescuro/100 rounded-full"
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
        </div>
        <div className="text-cinza flex flex-col gap-1">
          <Text>Coleção de NFTs: {data?.nfts?.length || 0}</Text>
          <Text>NFTs criados: {data?.nfts?.length || 0}</Text>
        </div>
        <div className="flex flex-col gap-1 text-cinza">
          <Text>Passes</Text>
          <Subtext>{data?.artTicket || '0'} farm pass disponível</Subtext>
          <Subtext>{data?.mintTicket || '0'} mint pass disponível</Subtext>
        </div>
      </div>
    </div>
  )
}
